<script setup>
import Badge from '../UI/Badge.vue'
import { computed } from 'vue'

const { contract } = defineProps({
  contract: Object,
})

const labelKey = computed(() => {
  if (false === contract.cession) {
    return 'contract.cession.relation.brokerage'
  }

  if (true === contract.managementMandate) {
    return 'contract.cession.relation.cession_with_management_mandate'
  }

  return 'contract.cession.relation.cession'
})
</script>

<template>
  <Badge type="secondary">
    {{ $t(labelKey) }}
  </Badge>
</template>
